import { type Item } from '@/components/wrapped/ActionCard';
import { type Claim } from '@/karehero-app/tell-us-once/benefits/ResultScreen';
import { RECIPIENT } from '@/karehero-app/tell-us-once/intake/content';

/**
 * Concept 2's Home: what to do for everyone you care for, in one list, each
 * tagged with who it is about.
 */
export const EVERYONE_ACTIONS: Item[] = [
  {
    id: 1,
    title: 'Finish the Attendance Allowance claim',
    regarding: RECIPIENT,
    createdBy: '',
    who: 'OP',
    schedule: '41 of 64 answered',
    files: [],
    kind: 'user',
  },
  {
    id: 2,
    title: 'Book a GP review',
    regarding: 'Brian',
    createdBy: 'Yasmin',
    who: 'OP',
    schedule: 'Due 28 Oct',
    overdue: true,
    files: [],
    kind: 'cam',
  },
  {
    id: 3,
    title: 'Send the council tax bill',
    regarding: RECIPIENT,
    createdBy: 'Yasmin',
    who: 'OP',
    schedule: 'Due Friday',
    files: [],
    kind: 'cam',
  },
  {
    id: 4,
    title: 'Check what Brian could get',
    regarding: 'Brian',
    createdBy: '',
    who: 'OP',
    schedule: "You said you'd do this later",
    files: [],
    kind: 'user',
  },
];

/**
 * Who each of the Actions designs' actions is about, by id, for the hub's
 * Actions tab: Margaret's unless it's here. Brian has a couple so the list
 * reads as everyone's.
 */
const ACTION_PEOPLE: Record<number, string> = { 2: 'Brian', 6: 'Brian' };
export const actionPerson = (action: { id: number }) =>
  ACTION_PEOPLE[action.id] ?? RECIPIENT;

/**
 * Benefits the check did not point at, so Money can show them under the ones
 * it did. Stand-ins until the rules say which apply to whom.
 */
export const OTHER_BENEFITS: Claim[] = [
  {
    icon: 'hand-holding-heart',
    name: "Carer's Allowance",
    description: 'For you, if you care 35 hours a week or more.',
  },
  {
    icon: 'id-card',
    name: 'Blue Badge',
    description: 'Parking closer to where you need to be.',
  },
];
